// src/environments/environment.staging.ts
export const environment = {
  production: false,
  apiUrl: 'https://api.uat.auditfixers.com',
  envName: 'staging', // added environment name
};
